module.exports = __webpack_public_path__ + "app/modals/wz-qws-confirm-remove-output-input-device.view.html";